import { PRODUCT_ATTRIBUTE_IDS } from "../../../shared/constants/productAttributes";

// ── Sort parameter keys (as stored in the panel settings registry) ────────────
//
// These are the canonical values of the `sorting_parameter.key` field emitted by
// the panel CMS. They correspond to the `_select_options.sorting_parameters` list.
// filterProducts uses the same strings in its sort switch.
export const SORT_PARAMETER = {
	FAVORITES:		PRODUCT_ATTRIBUTE_IDS.FAVORITES,
	INSOLATION:		PRODUCT_ATTRIBUTE_IDS.INSOLATION,
	COMPARE_AREA:	PRODUCT_ATTRIBUTE_IDS.COMPARE_AREA,
	AREA:           PRODUCT_ATTRIBUTE_IDS.AREA,
	BUILDING:       PRODUCT_ATTRIBUTE_IDS.BUILDING,
	GATE:           PRODUCT_ATTRIBUTE_IDS.GATE,
	ID_CAD:         PRODUCT_ATTRIBUTE_IDS.ID_CAD,
	OFFER:			PRODUCT_ATTRIBUTE_IDS.OFFER,
	PRICE:          PRODUCT_ATTRIBUTE_IDS.PRICE,
	ROOMS:          PRODUCT_ATTRIBUTE_IDS.ROOMS,
	STATUS:         PRODUCT_ATTRIBUTE_IDS.STATUS,
	TIERS:          PRODUCT_ATTRIBUTE_IDS.TIERS,
};

export const SORT_DIRECTION = {
	ASC: 'asc',
	DESC: 'desc',
};
